import React from 'react';

import PageWrapperNoChrome from './PageWrapperNoChrome';
import PageWrapperChromed from './PageWrapperChromed';

const PageWrapper = () => (
  <>
    <PageWrapperNoChrome />
    <PageWrapperChromed />
  </>
);

export default PageWrapper;
